import { useNavigate } from 'react-router-dom';
import { Panel } from '../ledger';
import { assignTeamColors, youStyle } from '../../utils/teamColors';
import { homeCardModel } from './homeCardModel';

// One added league on Home (mock homePage(): panel.lg). Colours come from the
// same assignment the league's own pages use, so "you" is the same colour here.
export function HomeLeagueCard({ league, onRetry, onSync, syncing = false, progress = 0, label = '' }) {
  const navigate = useNavigate();
  const m = homeCardModel(league);
  const slot = league.my_team_id != null ? assignTeamColors(league.league_id, league.team_ids).get(String(league.my_team_id)) : null;
  const open = () => navigate(`/league/${league.league_id}/home`);
  return (
    <Panel className="home-card" title={league.name ?? 'League'} meta={m.meta} bodyClassName="ledger-panel-body" style={youStyle(slot)} data-home-league={league.league_id}>
      {m.kind === 'error' && (
        <>
          <p>Couldn&apos;t load this league.</p>
          <button type="button" className="ledger-btn" onClick={onRetry}>Retry</button>
        </>
      )}
      {m.team && (
        <span className="home-team">
          <span className="ledger-team" style={m.team.mine ? { '--c': 'var(--you)' } : undefined}>{m.team.name}</span>
          {m.team.mine && <span className="ledger-you-tag">YOU</span>}
        </span>
      )}
      {m.rank && <div className="home-rank ledger-num">{m.rank}<small>{m.rankDetail}</small></div>}
      {(m.sentence || m.line) && <p>{m.sentence ?? m.line}</p>}
      {m.kind === 'unsynced' && (syncing ? (
        <>
          <div role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} aria-label={label || 'Syncing'}>
            <div className="home-progress"><div style={{ transform: `scaleX(${progress / 100})` }} /></div>
          </div>
          {label && <p className="ledger-state" aria-live="polite">{label}</p>}
        </>
      ) : (
        <button type="button" className="ledger-btn home-open" onClick={onSync}>Sync league</button>
      ))}
      {m.kind === 'pick' && <button type="button" className="ledger-btn home-open" onClick={open}>Pick your team</button>}
      {m.kind !== 'error' && m.kind !== 'pick' && m.kind !== 'unsynced' && <button type="button" className="ledger-btn home-open" onClick={open}>Open league</button>}
    </Panel>
  );
}

export default HomeLeagueCard;
